import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import onBannerClickInit from './onBannerClickInit'
import onBannerLoadedInit from './onBannerLoadedInit'

const useBannersCtrls = ({ clientId = '' }: ClientModel) => {
  const onBannerClick = onBannerClickInit(clientId)
  const onBannerLoaded = onBannerLoadedInit(clientId)

  return { onBannerClick, onBannerLoaded }
}

export default useBannersCtrls
